import { listVisibleHubRooms } from "../../js/theHub";
import RoomMark from "./RoomMark";

export default function ConventionHall({ unread = {}, onEnter }) {
  const rooms = listVisibleHubRooms();
  return (
    <section className="hub-hall" aria-label="Convention Hall" data-tour="hub-hall">
      <p className="the-hub-lead">Convention Hall</p>
      <p className="hub-hall__intro">
        {rooms.length} rooms. Step through a door for chat, listings, and announcements. The hall stays
        unhurried — a convention center, not a marketplace.
      </p>
      <ol className="hub-hall__grid">
        {rooms.map((room, index) => (
          <li key={room.id}>
            <article
              className={`hub-door${unread[room.id] ? " has-mail" : ""}${room.muted ? " is-muted" : ""}${
                room.boosted ? " is-boosted" : ""
              }${room.featured ? " is-featured" : ""}`}
              data-tour={index < 3 ? `hub-door-${index}` : undefined}
            >
              <RoomMark
                roomId={room.id}
                label={room.label}
                initials={room.initials}
                tone={room.tone}
                size={72}
              />
              <div className="hub-door__copy">
                <h2>{room.label}</h2>
                <p>{room.blurb}</p>
                {room.featured ? <p className="hub-door__flag">Featured</p> : null}
              </div>
              <button type="button" className="primary-btn" onClick={() => onEnter(room.id)}>
                Enter Room
                {unread[room.id] ? <em className="hub-door__pip">{unread[room.id]}</em> : null}
              </button>
            </article>
          </li>
        ))}
      </ol>
    </section>
  );
}
